<div id="loginModal" class="modal show" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #f5f5f5;">
        <img src="/assets/images/autoloopXRM_logo.png" class="img-responsive" />
      </div>
      <div class="modal-body">
        <form novalidate [formGroup]="loginForm" class="form col-md-12 center-block">
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Username" name="username" formControlName="username"
            />
            <div *ngIf="loginForm.controls['username'].touched && loginForm.controls['username'].hasError('required')" class="alert alert-danger">
              Username is required.
            </div>
          </div>
          <div class="form-group">
            <input type="password" class="form-control" placeholder="Password" name="password" formControlName="password"
            />
            <div *ngIf="loginForm.controls['password'].touched && loginForm.controls['password'].hasError('required')" class="alert alert-danger">
              Password is required.
            </div>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" placeholder="DealerId" name="dealerId" formControlName="dealerId"
              min="0" maxlength="10" />
            <div *ngIf="loginForm.controls['dealerId'].touched && (loginForm.controls['dealerId'].hasError('minLength') || loginForm.controls['dealerId'].hasError('maxLength'))"
              class="alert alert-danger">
              DealerID is invalid.
            </div>
            <div *ngIf="loginForm.controls['dealerId'].touched && loginForm.controls['dealerId'].hasError('required')" class="alert alert-danger">
              DealerID is required.
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-lg btn-block" (click)="login()" [disabled]="!loginForm.valid || isLoadingLogin == true">
              <span *ngIf="!isLoadingLogin">Sign in</span>
              <span *ngIf="isLoadingLogin">Loading...</span>
            </button>
          </div>
          <div class="alert alert-danger" *ngIf="errMsg">
            <strong>{{errMsg}}</strong>
          </div>
          <div class="alert alert-success" *ngIf="successMsg">
            <strong>{{successMsg}}</strong>
          </div>
          <div class="checkbox">
            <label>
              <input type="checkbox" (click)="remember()"> Remember me
            </label>
          </div>
        </form>
      </div>
      <div class="modal-footer center-block">
        <div class="col-md-12">
          <span>&copy;</span>
          <span>{{ settings.app.year }}</span>
          <span>-</span>
          <span>{{ settings.app.name }}</span>
          <span>{{ settings.app.description }}</span>
        </div>
      </div>
    </div>
  </div>
</div>